import { useEffect, useState } from 'react'
import type { FanslyApi } from './api'
import { accountOf, asObj, type FanslyAccount } from './data'
import { useFanslyApi } from './deps'

/** account/me per account, asked once per page load (it rarely changes and every page needs "self"). */
const cache = new Map<string, Promise<FanslyAccount>>()

export function loadMe(api: FanslyApi): Promise<FanslyAccount> {
  let out = cache.get(api.accountId)
  if (!out) {
    out = api.get<unknown>('/crm/account/me').then((r) => accountOf(asObj(r).account ?? r))
    out.catch(() => cache.delete(api.accountId))
    cache.set(api.accountId, out)
  }
  return out
}

/** Forget account/me (after a profile edit). */
export function forgetMe(accountId: string): void {
  cache.delete(accountId)
}

/** This Fansly account (the creator), or null until it has loaded. */
export function useMe(): FanslyAccount | null {
  const api = useFanslyApi()
  const [me, setMe] = useState<FanslyAccount | null>(null)
  useEffect(() => {
    let live = true
    loadMe(api)
      .then((m) => live && setMe(m))
      .catch(() => {})
    return () => {
      live = false
    }
  }, [api])
  return me
}
